import { render, staticRenderFns } from "./ApplicationLink.vue?vue&type=template&id=54d2eba6"
import script from "./ApplicationLink.vue?vue&type=script&lang=js"
export * from "./ApplicationLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports